var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFC2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.598 21.602h-.145c-.62-3.13-3.422-5.497-6.735-5.497-1.82 0-3.459.729-4.696 1.857a12.356 12.356 0 0 0-3.531-.51c-1.238 0-2.44.182-3.531.51a6.793 6.793 0 0 0-4.696-1.857c-3.313 0-6.08 2.367-6.735 5.497h-.146a1.383 1.383 0 1 0 0 2.767h.146c.619 3.13 3.422 5.497 6.735 5.497a6.875 6.875 0 0 0 6.88-6.88c0-.91-.182-1.784-.51-2.585.583-.11 1.201-.182 1.857-.182.655 0 1.274.073 1.856.182-.327.8-.51 1.675-.51 2.585a6.875 6.875 0 0 0 6.88 6.88c3.314 0 6.08-2.366 6.736-5.497h.145a1.383 1.383 0 1 0 0-2.767zM14.264 27.1c-2.257 0-4.114-1.856-4.114-4.113 0-2.257 1.857-4.114 4.114-4.114 2.257 0 4.113 1.857 4.113 4.114 0 2.257-1.856 4.113-4.113 4.113zm16.454 0c-2.257 0-4.114-1.856-4.114-4.113 0-2.257 1.857-4.114 4.114-4.114 2.257 0 4.113 1.857 4.113 4.114 0 2.257-1.856 4.113-4.113 4.113z",
    fill: "#EF0554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGlasses);
export default __webpack_public_path__ + "static/media/homeGlasses.6e6b966c79295e6415e799cba2219bf3.svg";
export { ForwardRef as ReactComponent };